module.exports = __webpack_public_path__ + "img/9788971994658.71d57b14.jpg";